import { useEffect, useEffectEvent, useRef, useState } from "react";
import SearchComponent from "../../components/SearchComponent";
import { ApiService } from "../../utils/ApiService";
import { showToast } from "../../common/Toast";
import { Avatar, formatDateTime } from "../../common/Functions";
import Pagination from "../../common/Pagination";
import CustomRangePicker from "../../components/CustomeRangePicker/CustomRangePicker";
import { capitalizeEachWord } from "../../utils/common";
import FullPageLoader from "../../common/FullPageLoader";

const Payout = () => {
    const [search, setSearch] = useState("");
    const [startingIndex, setStartingIndex] = useState(0);
    const [page, setPage] = useState(1);
    const [limit, setLimit] = useState(10);
    const [pagination, setPagination] = useState({
        currentPage: 1,
        totalPages: 1,
        totalUser: 5,
    });
    const [payouts, setPayouts] = useState([])
    const [showDatePicker, setShowDatePicker] = useState(false);
    const calendarRef = useRef(null);
    const [range,setRange] = useState({
        start: null,
        end: null
    });
    const inputRef = useRef(null);
    const filterRef = useRef(null)
    const [loading, setLoading] = useState(true);

    const fetchPayoutsList = async () => {
        try {
            
            const token = localStorage.getItem("auth_token")
            let res;
            if(range.start && range.end){
                res = await ApiService.get(
                    `admin/payout-list?search=${search}&startDate=${range.start}&endDate=${range.end}`,
                    {},
                    {
                        headers: {
                            Authorization: `${token}`,
                        },
                    }
                );
            } else {
                res = await ApiService.get(
                    `admin/payout-list?search=${search}`,
                    {},
                    {
                        headers: {
                            Authorization: `${token}`,
                        },
                    }
                );
            }

            console.log("PAYOUT LIST --> ", res)
            if(res.success){
                setPayouts(res.payoutList)
                setLoading(false)
            }
        } catch (error) {
            console.log("Error while fetching Payouts List --> ", error)
        }
    }

    useEffect(() => {
        const handleClickOutside = (event) => {
            if (
                showDatePicker &&
                filterRef.current &&
                !filterRef.current.contains(event.target)
            ) {
                setShowDatePicker(false);
            }
        };
    
        document.addEventListener("mousedown", handleClickOutside);
    
        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, [showDatePicker]);


    useEffect(() => {
        fetchPayoutsList();
    }, [search, range])

    const handlePagination = (newPage) => {
        if (newPage >= 1 && newPage <= pagination.totalPages) {
            setPage(newPage);
        }
    }

    const FilterButton = () => {
        return (
            <div
                ref={inputRef}
                placeholder="MM/DD/YYYY - MM/DD/YYYY"
                onClick={() => setShowDatePicker(!showDatePicker)}
                value={range}
                // onChange={(e) => setDateRange(e.target.value)}
                className="w-full text-[11px] font-normal relative px-4 pr-10 rounded-full h-[40px] flex items-center border  bg-white appearance-none cursor-pointer hover:border-gray-300 transition-colors outline-0 text-[12px]"
              >
                {/* MM/DD/YYYY - MM/DD/YYYY */}
                {range.start && range.end 
                  ? `${range.start.toLocaleDateString()} - ${range.end.toLocaleDateString()}`
                  : "MM/DD/YYYY - MM/DD/YYYY"}
              <svg
                width="14"
                height="14"
                className="absolute right-3 top-[10px] pointer-events-none"
                viewBox="0 0 14 14"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M4.66602 1.16667V2.91667"
                  stroke="#292D32"
                  strokeMiterlimit="10"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
                <path
                  d="M9.33398 1.16667V2.91667"
                  stroke="#292D32"
                  strokeMiterlimit="10"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
                <path
                  d="M2.04102 5.30249H11.9577"
                  stroke="#292D32"
                  strokeMiterlimit="10"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
                <path
                  d="M12.25 4.95834V9.91667C12.25 11.6667 11.375 12.8333 9.33333 12.8333H4.66667C2.625 12.8333 1.75 11.6667 1.75 9.91667V4.95834C1.75 3.20834 2.625 2.04167 4.66667 2.04167H9.33333C11.375 2.04167 12.25 3.20834 12.25 4.95834Z"
                  stroke="#292D32"
                  strokeMiterlimit="10"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
                <path
                  d="M9.15565 7.99168H9.16089"
                  stroke="#292D32"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
                <path
                  d="M9.15565 9.74168H9.16089"
                  stroke="#292D32"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
                <path
                  d="M6.99732 7.99168H7.00256"
                  stroke="#292D32"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
                <path
                  d="M6.99732 9.74168H7.00256"
                  stroke="#292D32"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
                <path
                  d="M4.83924 7.99168H4.84448"
                  stroke="#292D32"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
                <path
                  d="M4.83924 9.74168H4.84448"
                  stroke="#292D32"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
              </svg>
              </div>
        );
    };
    const handleRangeChange = (newRange) => {
        setRange(newRange)
        if(page!==1){
          setPage(1);
        }
    }

    return (
        <>
            {loading && <FullPageLoader />}
            <div className="flex-grow bg-gray-100 px-6 w-full overflow-auto h-[90vh]">
                <div className="flex flex-row items-center mb-6 justify-between pr-2">
                    <SearchComponent search={search} onChange={(e) => setSearch(e.target.value)} placeholder="Search by transaction id, event id..." />
                    <div className= "relative w-[350px]" ref={filterRef}>
                        <FilterButton label="Date" />
                        {showDatePicker && (
                            <div ref={calendarRef}>
                            <CustomRangePicker
                                range={range}
                                onRangeChange={handleRangeChange}
                                onApply={() => setShowDatePicker(false)}
                                onCancel={() => {
                                setRange({ start: null, end: null });
                                setShowDatePicker(false);
                                }}
                            />
                            </div>
                        )}
                    </div>    
                        
                </div>

                {<>
                    <div className="bg-white shadow rounded-2xl overflow-hidden mt-2">
                        <table className="w-full text-center">
                            <thead className="bg-gray-200 text-m text-black">
                                <tr>
                                    <th className="p-4 text-left font-normal">Date & Time</th>
                                    <th className="p-4 text-left font-normal">Host</th>
                                    <th className="p-4 text-left font-normal">Amount</th>
                                    <th className="p-4 text-left font-normal">Payout Id</th>
                                    <th className="p-4 text-left font-normal">Status</th>
                                </tr>
                            </thead>

                            <tbody>
                                {payouts.length ? (
                                    payouts.map((payout) => (
                                        <tr
                                            key={payout._id}
                                            className="border-t hover:bg-gray-50 cursor-pointer"
                                            >
                                            <td className="p-5 text-left font-normal text-[#4C4C4C] text-sm max-w-[100px]">{formatDateTime(payout.createdAt)}</td>
                                            {/* <td className="p-5 text-left font-normal text-[#4C4C4C] text-sm">{capitalizeEachWord(payout.userId.name)}</td> */}
                                            <td className="p-4">
                                                <div className="flex items-center gap-3">
                                                {/* Avatar: circle, fixed size, object-cover if image */}

                                                <Avatar name={payout.userId.name} image={payout.userId.image} size={32}/>


                                                {/* Name text */}
                                                <div className="text-sm font-normal text-[#4C4C4C]">
                                                    {capitalizeEachWord(payout.userId.name)}
                                                </div>
                                                </div>
                                            </td>
                                            <td className="p-5 text-left font-normal text-[#4C4C4C] text-sm">
                                                {String(payout.transferAmount || 0).padStart(2, "0")}
                                            </td>
                                            <td className="p-5 text-left font-normal text-[#4C4C4C] text-sm">{payout.payoutId ? "#"+payout.payoutId.slice(-6) : "-"}</td>
                                            <td className="p-5 text-left font-normal text-[#4C4C4C] text-sm">{capitalizeEachWord(payout.payoutStatus)}</td>
                                        </tr>
                                    ))
                                ) : (
                                    <tr>
                                        <td
                                            colSpan={5}
                                            className="text-center py-10 text-gray-500"
                                        >
                                            No results found
                                        </td>
                                    </tr>
                                )}
                            </tbody>

                        </table>

                    </div>
                    <Pagination
                        page={page}
                        totalPages={pagination.totalPages}
                        totalItems={pagination.totalUser}
                        limit={limit}
                        onPageChange={(newPage) => handlePagination(newPage)}
                    />
                </>}
            </div>
        </>
    )
}
export default Payout;